import { postRequest, getRequest } from "app/axiosClient";
import {
  showLoader,
  hideLoader,
} from "CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import {
  setLeadRecords,
  setLeadById,
  setLeadStatusCount,
  setMonthlyLeadStatuses,
  setSourceOfLeadCount,
  resetLeadRecords,
  setLeadCallsList,
  setLeadCallById,
  setLeadNoteById,
  setLeadNotesList,
  resetLeadNotesList,
  setLeadEmailsList,
  setLeadEmailById,
  resetLeadEmailsList,
  setActivitiesByDate,
} from "./LeadsSlice";
import {
  getAttachments,
  uploadAttachment,
} from "CommonComponents/Attachments/AttachmentsAPI";
import { resetAttachments } from "CommonComponents/Attachments/AttachmentsSlice";
import { getClientAPI } from "CommonComponents/Lookup/LookupAPI";
export const GetLeadsApi = (values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/GetLeadsList`, values)
      .then((res) => {
        dispatch(
          setLeadRecords({
            data: res?.data?.items,
            totalPages: res?.data?.totalPages,
            pageNo: values.pageNo,
            isSearch: values.isSearch,
          })
        );
        dispatch(hideLoader());
        return { payload: res?.data?.items };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Lead.Notification.Anunexpectederrorwhileretrievingprospectlist"
    );
    return false;
  }
};

export const GetLeadByIdApi = (leadId) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lead/GetLeadById?leadId=${leadId}`)
      .then((res) => {
        dispatch(setLeadById(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Lead.Notification.Failedtoretrieveprospectdetails"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Lead.Notification.Anunexpectederrorwhileretrievingprospectdetails"
    );
  }
};

export const UpdateLeadApi =
  (leadData, currentYear, pagination) => (dispatch) => {
    try {
      dispatch(showLoader());
      return postRequest(`api/Lead/UpdateLead`, leadData)
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Lead.Notification.Leadhassuccessfullyupdated"
          );
          const input = {
            pageNo: pagination?.pageNo || 1,
            pageSize: 10,
            searchQuery: "",
          };
          dispatch(GetLeadsApi(input));
          dispatch(getClientAPI());
          dispatch(leadStatusCountForBarChartAPI(currentYear));
          dispatch(getLeadSourceCountsAPI(currentYear));
          return res?.data;
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Lead.Notification.Failedtoupdatelead"
          );
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Lead.Notification.Anerroroccuredwhileupdatingleaddetails"
      );
      return false;
    }
  };
export const AddLeadApi = (leadData, input, currentYear) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/AddLead`, leadData)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "Lead.Notification.Leadhassuccessfullyadded"
        );
        dispatch(GetLeadsApi(input));
        dispatch(getClientAPI());
        dispatch(resetLeadRecords());
        dispatch(getLeadStatusCountAPI());
        dispatch(leadStatusCountForBarChartAPI(currentYear));
        dispatch(getLeadSourceCountsAPI(currentYear));
        return res?.data;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Lead.Notification.Failedtoaddlead"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Lead.Notification.Anunexpectederroroccuredwhileaddinglead"
    );
    return false;
  }
};
export const getLeadStatusCountAPI = () => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest("api/Lead/LeadStatusCount")
      .then((res) => {
        dispatch(setLeadStatusCount(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const leadStatusCountForBarChartAPI = (year) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lead/GetMonthlyStatusCounts?year=${year}`)
      .then((res) => {
        dispatch(setMonthlyLeadStatuses(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const getLeadSourceCountsAPI = (year) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Lead/GetLeadSourceCounts?year=${year}`)
      .then((res) => {
        dispatch(setSourceOfLeadCount(res?.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        const errorMessage = e?.response?.data?.Message || e?.message;
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Lookup.Notification.Unexpectederror",
          errorMessage,
          "Lookup.Notification.Pleasetryagainlater"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Lookup.Notification.Unexpectederror",
      "",
      "Lookup.Notification.Unexpectederrorretrievingroles"
    );
  }
};

export const saveLeadCallAPI = (leadData, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/SaveLeadCall`, leadData)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadCall.Notification.LeadCallSaved"
        );
        dispatch(getLeadCallsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadCall.Notification.Failedtoaddleadcall"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadCall.Notification.Anunexpectederroroccuredwhileaddingleadcall"
    );
    return false;
  }
};

export const getLeadCallsListAPI = (leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/GetLeadCallsList?leadId=${leadId}`, values)
      .then((res) => {
        dispatch(setLeadCallsList(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadCall.Notification.Anunexpectederrorwhileretrievingleadcalllist"
    );
    return false;
  }
};

export const editLeadCallAPI = (leadData, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/EditLeadCall`, leadData)
      .then((res) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadCall.Notification.LeadCallUpdated"
        );
        dispatch(getLeadCallsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadCall.Notification.Failedtoupdateleadcall"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadCall.Notification.Anunexpectederroroccuredwhileupdatingleadcall"
    );
    return false;
  }
};

export const getLeadCallByIdAPI = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`api/Lead/GetLeadCallById?id=${id}`)
      .then((res) => {
        dispatch(setLeadCallById(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadCall.Notification.Anunexpectederrorwhileretrievingleadcalldetails"
    );
    return false;
  }
};

export const deleteLeadCallByIdAPI = (id, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Lead/DeleteLeadCallById?id=${id}`)
      .then((res) => {
        dispatch(getLeadCallsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadCall.Notification.LeadCallDeleted"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadCall.Notification.Anunexpectederrorwhiledeletingleadcall"
    );
  }
};

export const addLeadNoteAPI = (noteData, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/AddLeadNote`, noteData)
      .then((res) => {
        dispatch(resetAttachments());
        dispatch(uploadAttachment(res?.data));
        dispatch(resetLeadNotesList());
        dispatch(getLeadNotessListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadNote.Notification.LeadNoteSaved"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadNote.Notification.Failedtoaddleadnote"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadNote.Notification.Anunexpectederroroccuredwhileaddingleadnote"
    );
    return false;
  }
};

export const getLeadNotessListAPI = (leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/GetLeadNotesList?leadId=${leadId}`, values)
      .then((res) => {
        dispatch(setLeadNotesList(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadNote.Notification.Anunexpectederrorwhileretrievingleadnotelist"
    );
    return false;
  }
};

export const editLeadNoteAPI = (noteData, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/EditLeadNote`, noteData)
      .then((res) => {
        dispatch(resetAttachments());
        dispatch(uploadAttachment(res?.data));
        dispatch(resetLeadNotesList());
        dispatch(getLeadNotessListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadNote.Notification.LeadNoteUpdated"
        );
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadNote.Notification.Failedtoupdateleadnote"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadNote.Notification.Anunexpectederroroccuredwhileupdatingleadnote"
    );
    return false;
  }
};

export const getLeadNoteByIdAPI = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`/api/Lead/GetLeadNoteByLeadId?id=${id}`)
      .then((res) => {
        dispatch(setLeadNoteById(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadNote.Notification.Anunexpectederrorwhileretrievingleadnotedetails"
    );
    return false;
  }
};

export const deleteLeadNoteByIdAPI = (id, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Lead/DeleteLeadNoteById?id=${id}`)
      .then((res) => {
        dispatch(uploadAttachment(res?.data));
        dispatch(getLeadNotessListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadNote.Notification.LeadNoteDeleted"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadNote.Notification.Anunexpectederrorwhiledeletingleadnote"
    );
  }
};

export const addLeadEmailAPI = (emailObj, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/SaveLeadEmail`, emailObj)
      .then((res) => {
        dispatch(resetAttachments());
        dispatch(uploadAttachment(res?.data));
        dispatch(resetLeadEmailsList());
        dispatch(getLeadEmailsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadMail.Notification.LeadMailSaved"
        );
        //dispatch(GetLeadsApi(input));
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadMail.Notification.Failedtoaddleadmail"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadMail.Notification.Anunexpectederroroccuredwhileaddingleadmail"
    );
    return false;
  }
};

export const getLeadEmailsListAPI = (leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/GetLeadEmailsList?leadId=${leadId}`, values)
      .then((res) => {
        dispatch(setLeadEmailsList(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadMail.Notification.Anunexpectederrorwhileretrievingleadmaillist"
    );
    return false;
  }
};

export const editLeadEmailAPI = (emailObj, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(`api/Lead/EditLeadEmail`, emailObj)
      .then((res) => {
        dispatch(resetAttachments());
        dispatch(uploadAttachment(res?.data));
        dispatch(resetLeadEmailsList());
        dispatch(getLeadEmailsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadMail.Notification.LeadMailUpdated"
        );
        //dispatch(GetLeadsApi(input));
        return true;
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "LeadMail.Notification.Failedtoupdateleadmail"
        );
        return false;
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadMail.Notification.Anunexpectederroroccuredwhileupdatingleadmail"
    );
    return false;
  }
};

export const getLeadEmailByIdAPI = (id) => (dispatch) => {
  try {
    dispatch(showLoader());
    return getRequest(`/api/Lead/GetLeadEmailById?id=${id}`)
      .then((res) => {
        dispatch(setLeadEmailById(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadMail.Notification.Anunexpectederrorwhileretrievingleadmaildetails"
    );
    return false;
  }
};

export const deleteLeadEmailByIdAPI = (id, leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    postRequest(`api/Lead/DeleteLeadEmailById?id=${id}`)
      .then((res) => {
        dispatch(uploadAttachment(res?.data));
        dispatch(getLeadEmailsListAPI(leadId, values));
        dispatch(getLeadActivitiesByDateAPI(leadId, values));
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "success",
          "Common.Success",
          "",
          "LeadMail.Notification.LeadMailDeleted"
        );
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadMail.Notification.Anunexpectederrorwhiledeletingleadmail"
    );
  }
};

export const getLeadActivitiesByDateAPI = (leadId, values) => (dispatch) => {
  try {
    dispatch(showLoader());
    return postRequest(
      `api/Lead/GetLeadActivitiesByDate?leadId=${leadId}`,
      values
    )
      .then((res) => {
        dispatch(setActivitiesByDate(res?.data));
        dispatch(hideLoader());
        return { payload: res?.data };
      })
      .catch((e) => {
        dispatch(hideLoader());
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "LeadActivity.Notification.Anunexpectederrorwhileretrievingactivities"
    );
    return false;
  }
};

export const updateLeadStatusAPI =
  (leadId, newStatusId, reason = "") =>
  (dispatch) => {
    try {
      dispatch(showLoader());
      let query = `leadId=${leadId}&newStatusId=${newStatusId}`;
      if (reason?.trim()) {
        query += `&rejectionReason=${encodeURIComponent(reason)}`;
      }
      return postRequest(`api/Lead/UpdateLeadStatus?${query}`)
        .then((res) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "LeadView.StatusUpdateMessage"
          );
          return true;
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "LeadView.FailedToUpdateStatus"
          );
          return false;
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "LeadView.Error.UpdateLeadStatus"
      );
      return false;
    }
  };
